import axios from "axios";
import { getAuthToken, setAuthToken } from "../utils/tokenStorage";
import { logout } from "../utils/authActions";
import config from "../config";

const localStorageRefreshToken = localStorage.getItem("refreshToken");

const api = axios.create({
  baseURL: config.API_BASE_URL,
  withCredentials: true,
});

// Attach Access Token Automatically
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-Refresh Token if 401 (Unauthorized)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.status === 401 &&
      error.config &&
      !error.config.__isRetry
    ) {
      error.config.__isRetry = true;
      try {
        const { data } = await axios.post(
          `${config.API_BASE_URL}auth/refresh`,
          { localStorageRefreshToken: localStorageRefreshToken },
          { withCredentials: true }
        );
        setAuthToken(data.accessToken);
        error.config.headers.Authorization = `Bearer ${data.accessToken}`;
        return api.request(error.config);
      } catch (refreshError) {
        // logout();
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
